import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import React from 'react'

import useTranslate from '../../../../lib/hooks/use-translate'
import { staffDocumentTypeEnumMapping } from '../../../../lib/types/enums/common/document-status.enum'
import { StaffDocument } from '../../../../lib/types/models/staff/staff'
import DisplayImageInfo from '../../../elements/display-image-info'

type Props = {
  title: string
  document: StaffDocument
}

const StaffDocumentPreview: React.FC<Props> = ({ title, document }) => {
  const { t } = useTranslate()
  return (
    <div className={'flex flex-col gap-2'}>
      <Typography
        variant={'body-medium'}
        className={'text-center'}
        color={tailwindColors.grey.DEFAULT}
      >
        {title}
      </Typography>
      <DisplayImageInfo
        file={document.file}
        label={staffDocumentTypeEnumMapping(document, t).label}
      />
    </div>
  )
}

export default StaffDocumentPreview
